"use client";

import { useMutation } from "@tanstack/react-query";
import type {
  LinkTelegramFailureResponse,
  LinkTelegramSuccessResponse,
} from "@/generated/fastapi";
import { linkTelegram } from "./linkTelegram";

export default function useLinkTelegramMutation(accessToken?: string) {
  return useMutation<
    LinkTelegramSuccessResponse | LinkTelegramFailureResponse,
    Error
  >({
    mutationFn: async () => {
      if (!accessToken) {
        throw new Error("Missing access token");
      }

      return linkTelegram(accessToken);
    },
  });
}
